import { OverrideInterface } from '../interfaces';

export const MuiCheckbox: OverrideInterface<'MuiCheckbox'> = {
  styleOverrides: {
    root: {
      fontFamily: 'icomoon',
      '& svg': {
        display: 'none',
      },
      '&:before': {
        content: '"\\e907"',
      },
      '&.Mui-checked:before': {
        content: '"\\e917"',
      },
    },
  },
};
